import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import {
  Autocomplete,
  createFilterOptions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { GetAllEmployeeAction } from "../../../../redux/actions/employeeActions";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
import notify from "../../../Notifcation";
import {
  DeleteAdminRequestAction,
  GetAllAdminRequestAction,
} from "../../../../redux/actions/AdminRequestAction";
import axios from "axios";
import fileDownload from "js-file-download";
import dayjs from "dayjs";
const filter = createFilterOptions();
const Display = ({
  userData,
  key,
  setKey,
  Datee,
  setDate,
  DateFrom,
  setDateFrom,
  DateTo,
  setDateTo,
  TimeFrom,
  setTimeFrom,
  TimeTo,
  setTimeTo,
  Request,
  setRequest,
  ApprovedById,
  setApprovedById,
  NumberOfHours,
  NumberOfDays,
  Months,
  time,
  settime,
  Day,
  setDay,
  showCircleType,
  setshowCircleType,
  showSefam,
  setshowSefam,
  duration,
  setDuration,
  showSefak,
  setshowSefak,
  selectedFile,
  setSelectedFile,
  NoteFile,
  setNoteFile,
  Note,
  setNote,
  FileeBase64,
  setBase64,
  EmployeesId,
  setEmployeesId,
  isEdit,
  setIsEdit,
  Eye,
  setEye,
  AdminrequestId,
  setAdminrequestId,
  setNumberOfDays,
  setNumberOfHours,
  NumberOfAvaDays,
  setNumberOfAvaDays,
  BorrowValue,
  setBorrowValue,
}) => {
  const [Dateeto, setDateto] = useState("");
  const [Dateefrom, setDatefrom] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [Searchkey, setSearchkey] = useState("");
  const [loading, setLoading] = useState(true);
  const AllEmplyee = useSelector((state) => state.EmployeeR.GetEmployee);

  const PageSize = 7;
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setAdminrequestId(itemid);
  };
  const onPress = async (page) => {
    await dispatch(
      GetAllAdminRequestAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  useEffect(() => {
    dispatch(GetAllEmployeeAction());
  }, []);
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAdminRequestAction(AdminrequestId));
    setLoading(false);
    setAdminrequestId(null);
    setshowDelete(false);
    setIsPress(false);
  };

  const Update = (item) => {
    setKey("enter");
     setEmployeesId({
          name: item.employeeName,
          id: item.employeeId,
        });
        setDate(item.date);
        setRequest(item.request);
        setNote(item.note);
        setBorrowValue(item.borrowValue);
    
        setDateFrom(item.dateFrom);
        setDateTo(item.dateTo);
        setTimeFrom(dayjs(`1970-01-01T${item.timeFrom}`));
        setTimeTo(dayjs(`1970-01-01T${item.timeTo}`));
    
        setNumberOfDays(item.numberOfDays);
        setNumberOfHours(item.numberOfHours);
        setAdminrequestId(item.id);
        setApprovedById(item.approvedById !== 0 ? true : false);
        setNoteFile(item.fileDescription);  

    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setKey("enter");
  setEmployeesId({
       name: item.employeeName,
       id: item.employeeId,
     });
     setDate(item.date);
     setRequest(item.request);
     setNote(item.note);
     setDateFrom(item.dateFrom);
     setBorrowValue(item.borrowValue);
     setDateTo(item.dateTo);
     setTimeFrom(
       item.timeFrom !== null ? dayjs(`1970-01-01T${item.timeFrom}`) : ""
     );
     setTimeTo(item.timeTo != null ? dayjs(`1970-01-01T${item.timeTo}`) : "");
     setNoteFile(item.fileDescription);
 
     setNumberOfDays(item.numberOfDays);
     setNumberOfHours(item.numberOfHours);
     setAdminrequestId(item.id);
     setApprovedById(item.approvedById !== 0 ? true : false);
 
    setIsEdit(false);
    setEye(true);
  };

  const All = useSelector((state) => state.AdminRequestR.GetAdminRequest);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      GetAllAdminRequestAction(
        `To=${Dateeto}&From=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}&Request=${Request}&EmployeeId=${
          EmployeesId ? EmployeesId.id : null
        }`
      )
    );
  }, [Searchkey, Dateeto, Dateefrom,EmployeesId, Request, PageSize]);
  const handleSubmit = async () => {
    await dispatch(
      GetAllAdminRequestAction(
        `To=${Dateeto}&From=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}&Request=${Request}&EmployeeId=${
          EmployeesId ? EmployeesId.id : null
        }`
      )
    );
  };

  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  const DEL = useSelector((state) => state.AdminRequestR.DeleteAdminRequest);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, admin request deleted successfully"
          ) {
            dispatch(GetAllAdminRequestAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);

        // setLoading(true);
      }
    }
  }, [loading]);

  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {Dateefrom ? Dateefrom.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ من"
                variant="outlined"
                type="date"
                value={Dateefrom}
                onChange={(e) => setDatefrom(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <div className="dateee">
                {Dateeto ? Dateeto.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ إلى"
                variant="outlined"
                type="date"
                value={Dateeto}
                onChange={(e) => setDateto(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <Autocomplete
                value={EmployeesId}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setEmployeesId({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setEmployeesId({
                      name: newValue.inputValue,
                    });
                  } else {
                    setEmployeesId(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  Array.isArray(AllEmplyee && AllEmplyee.data)
                    ? AllEmplyee.data.filter((e) => e.isAccountActive === true)
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.name}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الموظف
                      </Typography>
                    }
                  />
                )}
              />
            </div>
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    طلب إداري
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Request}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      طلب إداري
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  onChange={(e) => {
                    setRequest(e.target.value);
                  }}>
                  <MenuItem value={"RegularLeave"}>اجازة اعتيادية</MenuItem>
                  <MenuItem value={"EmergencyLeave"}>اجازة عارضة</MenuItem>
                  <MenuItem value={"AnnualLeave"}>اجازة سنوية</MenuItem>
                  <MenuItem value={"SickLeave"}>اجازة مرضي</MenuItem>
                  <MenuItem value={"PermissionToLeave"}> اذن انصراف</MenuItem>
                  <MenuItem value={"PermissionForDelay"}> اذن تأخير</MenuItem>
                  <MenuItem value={"OfficialTaskPermit"}> اذن مأمورية</MenuItem>
                  <MenuItem value={"ComplaintRequest"}>طلب شكوى</MenuItem>
                  <MenuItem value={"InquiryRequest"}> طلب استفسار</MenuItem>
                  <MenuItem value={"BorrowRequest"}> طلب سلفة</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                value={Searchkey}
                onChange={(e) => setSearchkey(e.target.value)}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        </Container>
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                نوع الطلب <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                من<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                إلى<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                عدد<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                ادخال / مراجعة <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>

              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {All && All.data && All.data.length > 0
              ? All.data.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                      <td>{item.employeeName}</td>
                      <td>
                        {item.request === "RegularLeave"
                          ? "اجازة اعتيادية"
                          : item.request === "EmergencyLeave"
                          ? "اجازة عارضة"
                          : item.request === "AnnualLeave"
                          ? "اجازة سنوية"
                          : item.request === "SickLeave"
                          ? "اجازة مرضي"
                          : item.request === "PermissionToLeave"
                          ? "اذن انصراف"
                          : item.request === "PermissionForDelay"
                          ? "اذن تأخير"
                          : item.request === "OfficialTaskPermit"
                          ? "اذن مأمورية"
                          : item.request === "ComplaintRequest"
                          ? "طلب شكوى"
                          : item.request === "InquiryRequest"
                          ? "طلب استفسار"
                          : item.request === "BorrowRequest"
                          ? "طلب سلفة"
                          : ""}
                      </td>
                      <td>
                        {item.timeFrom !== null
                          ? item.timeFrom
                          : item.dateFrom !== null
                          ? new Date(item.dateFrom).toLocaleDateString("en-GB")
                          : ""}
                      </td>
                      <td>
                        {item.timeTo !== null
                          ? item.timeTo
                          : item.dateTo !== null
                          ? new Date(item.dateTo).toLocaleDateString("en-GB")
                          : ""}
                      </td>
                      <td>
                        {item.numberOfDays !== null
                          ? item.numberOfDays + " أيام"
                          : item.numberOfHours !== null
                          ? item.numberOfHours
                          : ""}
                      </td>
                      <td>{item.approvedByName}</td>
                      <td>{item.note}</td>
                      <td>
                        {item.fileUrl !== null ? (
                          <>
                            <button
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleShowpopup(item.fileUrl)}>
                              {" "}
                              <i className="fa-solid fa-paperclip"></i>
                            </button>
                            <span>{item.fileDescription}</span>
                          </>
                        ) : (
                          " "
                        )}
                      </td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        <div className="mod">
          <Modal
            show={showDelete}
            onHide={handleCloseDelete}
            backdrop="static"
            centered
            contentClassName="cont"
            keyboard={false}
            style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
            {/* <Modal.Header closeButton>
                                      <Modal.Title> </Modal.Title>
                                    </Modal.Header> */}
            <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="close"
                onClick={handleCloseDelete}>
                إغلاق
              </Button>
              <Button
                variant="primary"
                className="edit"
                onClick={handelDeleteItem}>
                موافق
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <div className="popimg">
          <Modal
            show={popup}
            onHide={handleClosepopup}
            backdrop="static"
            centered
            keyboard={false}
            contentClassName="popimg"
            style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
            <Modal.Header closeButton>
              <Modal.Title>عرض المستند</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {" "}
              {ContentFile.split(".").pop().toLowerCase() === "png" ||
              ContentFile.split(".").pop().toLowerCase() === "jpg" ||
              ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
              ContentFile.split(".").pop().toLowerCase() === "svg" ? (
                <img src={ContentFile} alt="" />
              ) : (
                <Button
                  variant="secondary"
                  className="close"
                  onClick={() =>
                    handleDownload(
                      ContentFile,
                      `document.${ContentFile.split(".").pop().toLowerCase()}`
                    )
                  }>
                  تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                  <i className="fa-solid fa-file-export"></i>
                </Button>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="close"
                onClick={handleClosepopup}>
                إغلاق
              </Button>
              {ContentFile.split(".").pop().toLowerCase() === "png" ||
              ContentFile.split(".").pop().toLowerCase() === "jpg" ||
              ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
              ContentFile.split(".").pop().toLowerCase() === "svg" ? (
                <Button
                  variant="secondary"
                  className="close"
                  onClick={() =>
                    handleDownload(
                      ContentFile,
                      `document.${ContentFile.split(".").pop().toLowerCase()}`
                    )
                  }
                  // onClick={() =>
                  //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                  // }
                >
                  تحميل الصورة
                </Button>
              ) : null}
              {/* <a  href={ContentFile}  className="close" >
                            تحميل الملف
                          </a> */}
            </Modal.Footer>
          </Modal>
        </div>
        <button className="buttonadd">تصدير</button>
      </div>
    </>
  );
};
export default Display;
